export const AgentLineClaw = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M8.37266 12C8.85266 12.72 10.9727 13.5 11.9727 13.8C17.0727 15 19.4727 12 19.7727 10.5C20.0127 9.3 20.4727 9.6 20.6727 9.9C20.9727 11.1 21.5727 16.2 17.3727 19.2C14.0127 21.6 9.97266 20.6 8.37266 19.8L5.97266 21C3.57266 20.52 2.97266 18.6 2.97266 17.7L4.47259 15.9C3.27259 14.1 3.27259 10.2 4.17259 8.1C5.07259 6 7.47259 3 12.5726 3C16.6526 3 18.5727 5.1 18.8727 6C14.6727 6.9 11.9727 8.7 11.3727 13.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);
